import {
  WALLET_AC_REQUIRED_SUCCESS,
  WALLET_AC_REQUIRED_FAILED,
  RESET_WALLET_AC_REQUIRED,
  LOADING_WALLET_AC_REQUIRED,
  NETWORK_ERROR_WALLET_AC_REQUIRED,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetWalletAcRequired = () => {
  return { type: RESET_WALLET_AC_REQUIRED };
};

const getWalletAcRequired = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_WALLET_AC_REQUIRED });
  await partnerServices
    .post("getWalletACRequiredRoles", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(walletAcRequiredsuccess(res.data));
          // history.push({ pathname: "/index/homepage" });
          break;
        default:
          dispatch(walletAcRequiredfailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_WALLET_AC_REQUIRED, payload: err });
    });
};
function walletAcRequiredsuccess(data) {
  return {
    type: WALLET_AC_REQUIRED_SUCCESS,
    payload: data,
  };
}
function walletAcRequiredfailed(data) {
  return {
    type: WALLET_AC_REQUIRED_FAILED,
    payload: data,
  };
}

export { resetWalletAcRequired, getWalletAcRequired };
